import { washArabic, washNesTabThree } from '@/utils/wash.js'
export const washData = (node) => {
  washNesTabThree(node)
  washArabic(node)
}
